import * as React from "react";

function Chat1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 52V18.58A6.59 6.59 0 0 1 14.58 12h34.84A6.59 6.59 0 0 1 56 18.58v22.84A6.59 6.59 0 0 1 49.42 48H16z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 24,
    x2: 48,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 36,
    x2: 48,
    y2: 36
  }));
}

export default Chat1Icon;